import CsrfUtil from '@terrestris/base-util/dist/CsrfUtil/CsrfUtil';
export const getCsrfTokenHeader = () => {
    let csrfToken = CsrfUtil.getCsrfValueFromCookie();
    if (!csrfToken) {
        csrfToken = CsrfUtil.getCsrfValue();
    }
    if (!csrfToken) {
        return {};
    }
    return {
        'X-XSRF-TOKEN': csrfToken
    };
};
//# sourceMappingURL=getCsrfTokenHeader.js.map